export const NAVIGATE = 'NAVIGATE';
export const NAVIGATION_COMPLETE = 'NAVIGATION_COMPLETE';

export const navigateTo = (path: string, options = {}) => ({
  type: NAVIGATE,
  payload: { path, options },
});

export const navigationComplete = () => ({
  type: NAVIGATION_COMPLETE,
});
